import styled from 'styled-components'

export interface ChildlessPlaceholderUiProps {
  title?: string
  isCreateBlockActive: boolean
}

const ChildlessPlaceholderUi = styled.div.attrs(({ title }) => ({
  title,
}))<ChildlessPlaceholderUiProps>`
  display: flex;
  min-height: 50px;
  flex-direction: column;
  font-size: 16px;
  color: #d0d7de;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  ${p => !p.isCreateBlockActive && `border: 1px dashed #969fa6;`};
  flex: 1;
`

export default ChildlessPlaceholderUi
